import React from "react";
import { ExerciseSetNumberType } from "../../../constants";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  mark: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 33,
    height: 33,
    borderRadius: "50%",
    border: `1px solid`,
    fontWeight: 500,
    fontSize: 14,
  },
  regular: {
    color: theme.palette.primary.main,
  },
  warmUp: {
    color: theme.palette.warning.main,
  },
  dropSet: {
    color: theme.palette.info.main,
  },
  failure: {
    color: theme.palette.error.main,
  },
  disabled: {
    color: theme.palette.text.disabled,
  },
}));

type HistorySetNumberTypeMarkingProps = {
  setNumber: string | number;
  type: ExerciseSetNumberType;
  disabled?: boolean;
  className?: string;
};

const HistorySetNumberTypeMarking = ({
  setNumber,
  type,
  disabled,
  className,
}: HistorySetNumberTypeMarkingProps) => {
  const s = useStyles();

  switch (type) {
    case ExerciseSetNumberType.WARM_UP:
      return (
        <Typography
          className={clsx(s.mark, s.warmUp, disabled && s.disabled, className)}
        >
          W
        </Typography>
      );
    case ExerciseSetNumberType.DROP_SET:
      return <Typography className={clsx(s.mark, s.dropSet)}>D</Typography>;
    case ExerciseSetNumberType.FAILURE:
      return (
        <Typography
          className={clsx(s.mark, s.failure, disabled && s.disabled, className)}
        >
          F
        </Typography>
      );
    case ExerciseSetNumberType.REGULAR_SET:
    default:
      return (
        <Typography
          className={clsx(s.mark, s.regular, disabled && s.disabled, className)}
        >
          {setNumber}
        </Typography>
      );
  }
};

export default HistorySetNumberTypeMarking;
